<div class="busy-indicator-root" *ngIf="busyService.isBusy">
  <mat-spinner color="accent"></mat-spinner>
</div>